import { createActions } from 'redux-actions'

export const INIT_ATTRIBUTE_INFO = "INIT_ATTRIBUTE_INFO";

export const REQUEST_ATTRIBUTE_START = "REQUEST_ATTRIBUTE_START";
export const REQUEST_ATTRIBUTE_SUCCESS = "REQUEST_ATTRIBUTE_SUCCESS";
export const REQUEST_ATTRIBUTE_FAIL = "REQUEST_ATTRIBUTE_FAIL";

export const {

  initAttributeInfo,
  requestAttributeStart,
  requestAttributeSuccess,
  requestAttributeFail,

} = createActions({

  [INIT_ATTRIBUTE_INFO]: (req) => ({ req }),

  [REQUEST_ATTRIBUTE_START]: (req) => ({ ...req }),
  [REQUEST_ATTRIBUTE_SUCCESS]: (res) => ({ res }),
  [REQUEST_ATTRIBUTE_FAIL]: (res) => ({ res }),

})


